import { isThisACase } from "../../../lib/script";
import BodySimpleModalV3 from "../../common/modal/BodySimpleModalV3";

export default function PatientOrChart({item, color}) {

    if (isThisACase(item) === null) {
        return null
    }
    return <div>
        {isThisACase(item) ? <BodySimpleModalV3 message={'Chart'}>
            <i className='ti ti-folder' style={{color: color}}></i>            
        </BodySimpleModalV3>
        :
        <BodySimpleModalV3 message={'Person'}>
            <i className='ti ti-world' style={{color: color}}></i>
        </BodySimpleModalV3>}
    </div>
}